<template>
    <input
        data-info="Normal Component"
        :value="value"
        @input="$emit('input', $event.target.value)"
        v-bind="$attrs"
        v-on="listenersWithoutInput"
        :aria-label="ariaLabel"
        :aria-labelledby="ariaLabelledby"
        :disabled="disabled"
        :tabindex="tabindex"
        ref="input"
    />
</template>
  
<script>
import BaseInputMixin from "~/mixins/base-input";
export default {
    name: "BaseInput",
    inheritAttrs: false,
    mixins: [BaseInputMixin],
}
</script>
<style>
  input.input:placeholder-shown {
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  input.input::placeholder {
     color: #767676 !important;
     text-overflow: ellipsis;
  }
  input.input.has-right-tag::placeholder {
    color: transparent !important;
  }
  input.input.has-right-tag:placeholder-shown + .label {
    display: block;
    right: 4.5rem;
    overflow: hidden;
    color: #767676;
    font-size: 1rem;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
</style>